module.exports = __webpack_public_path__ + "img/pepcid_ac_tablets_maximum_strength.af0206a2.jpg";